// 引入初始化的样式文件
import "@/styles/common.scss";
import "@/styles/admin.scss";
import "@/assets/font/fonts.css";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

import { createApp } from "vue";
import { createPinia } from "pinia";
import Element from "element-plus";
import "element-plus/dist/index.css";
import "@/styles/mg-checkbox.scss";
import locale from "element-plus/es/locale/lang/zh-cn"; //中文
// 将插件添加到 pinia 实例上
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import ComponentConfig from "@/config/ComponentConfig";
import VueVirtualScroller from "vue-virtual-scroller";
import * as Sentry from "@sentry/vue";
import App from "./App.vue";
import router from "./router";

// 引入全局守卫文件
import "./guard";
// 引入懒加载指令插件并注册
import { lazyPlugin } from "@/directives";

const app = createApp(App);

function initSentry() {
    if (import.meta.env.PROD)
        Sentry.init({
            app,
            dsn: "https://05af788ac810abc6566c8906151d5030@sentry.bi.mgmos.com.cn/37",
            sendDefaultPii: true,
            tracesSampleRate: 1.0,
            environment: import.meta.env.VITE_ENV,
            integrations: [
                Sentry.vueIntegration({
                    tracingOptions: { trackComponents: true }
                }),
                Sentry.browserTracingIntegration({ router })
            ]
        });
}

initSentry();


ComponentConfig.createComponent(app);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(Element, {
    locale
});
app.use(pinia);
app.use(router);
app.use(lazyPlugin);
app.use(VueVirtualScroller);
app.mount("#app");

